var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-empty" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("p", { staticClass: "go-info-lead" }, [
      _vm._v(_vm._s(_vm.$t("my-create.ask-goover.no-data.title"))),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "go-info-text" }, [
      _vm._v(_vm._s(_vm.$t("my-create.ask-goover.no-data.desc"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "go-btn-area" }, [
      _c(
        "button",
        {
          staticClass: "btn go-btn-default",
          attrs: { type: "button" },
          on: { click: _vm.navigateToHome },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("my-create.common.no-data.get-started")) +
              "\n      "
          ),
          _c("i", { staticClass: "go-icon-16 go-icon-chevron-right" }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-icon-wrap" }, [
      _c("i", { staticClass: "go-icon-48 go-icon-alert-circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }